import { DataService } from "@/services/data";
import { ApprenticeshipAssignationType } from "@/types/apprenticeship/assignation";
import { ApprenticeshipDepartmentType } from "@/types/apprenticeship/department_assignation";
import { PaginatedResponse } from "@/types/common";
import { ProductType } from "@/types/content/product";
import { SFOwnerFieldType } from "@/types/salesforce/fields";
import { RouteObject } from "react-router-dom";

const ApprenticeSettingsRoute: RouteObject = {
    path: "alternance",
    children: [
        {
            path: "attributions",
            async lazy() {
                let { AssignationSettings } = await import("@/pages/settings/apprenticeship/assignations");
                return { Component: AssignationSettings };
            },
            loader: async () => {
                const departments = (await DataService.client.url(`/apprenticeship/department_assignations/?page_size=250`).get().json()) as PaginatedResponse<ApprenticeshipDepartmentType>;
                const assignations = (await DataService.client.url(`/apprenticeship/assignations/?page_size=250`).get().json()) as PaginatedResponse<ApprenticeshipAssignationType>;
                const agents = await DataService.client.url(`/apprenticeship/assignations/agents/`).get().json();
                const products = (await DataService.client.url(`/apprenticeship/products/`).get().json()) as PaginatedResponse<ProductType>;
                return { departments: departments?.results ?? [], agents, assignations: assignations?.results ?? [], products: products?.results ?? [] };
            },
        },
        {
            path: "disponibilites",
            async lazy() {
                let { AvailabilitiesSettings } = await import("@/pages/settings/apprenticeship/availabilities");
                return { Component: AvailabilitiesSettings };
            },
            loader: async () => {
                const cap = (await DataService.client.url(`/apprenticeship/registrations/cap/`).get().json()) as SFOwnerFieldType[];
                const csm = (await DataService.client.url(`/apprenticeship/registrations/csm/`).get().json()) as SFOwnerFieldType[];
                return { users: [...cap, ...csm] };
            }
        }
    ]
};

export default ApprenticeSettingsRoute;
